/**
 * LuckyTask Admin - 主入口文件
 *
 * 功能：
 * - 初始化 Vue 应用
 * - 注册路由、状态管理、i18n
 * - 配置全局组件和插件
 */
import { createApp } from "vue";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import App from "./App.vue";
import router from "./router";
import i18n from "./locales";
import { setupDirectives } from "./directives";
import { setupInterceptors } from "./utils/request";
import { apiClient } from "./api/mutator";

// 导入全局样式
import "./styles/index.scss";
import "element-plus/dist/index.css";
import "element-plus/theme-chalk/dark/css-vars.css";
import "nprogress/nprogress.css";

// 创建应用实例
const app = createApp(App);

// 创建 Pinia 实例并配置持久化
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

// 注册插件
app.use(pinia);
app.use(router);
app.use(i18n);

// 注册全局指令
setupDirectives(app);

// 配置 Axios 拦截器
setupInterceptors(apiClient);

// 配置路由守卫
import { setupRouterGuard } from "./router/guard";
setupRouterGuard(router);

// 挂载应用
const appInstance = app.mount("#app");
export default appInstance;
